// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"534d0efb","393":"52f4435e"}[chunkId] + ".chunk.css";
};